import { useEffect, useState } from "react";
import { useLocalization } from "@fluent/react";
import { Button, TableAutocomplete } from "@narmi/design_system";
import { getRecipientById } from "./BulkPaymentTable";

type RecipientSelectorType = {
  rowIndex: number;
  recipients: API.Recipient[];
  form: any;
  handleClickAddRecipient: (rowIndex: number) => void;
  handleClickEditRecipient: (
    recipientId: API.RecipientId,
    rowIndex?: number
  ) => void;
  setCustomAlertCopy: (copy: string) => void;
  error?: boolean;
};

const RecipientSelector = ({
  rowIndex,
  recipients,
  form,
  handleClickAddRecipient,
  handleClickEditRecipient,
  setCustomAlertCopy,
  error,
}: RecipientSelectorType) => {
  const { l10n } = useLocalization();
  const [recipientInputDisplayValue, setRecipientInputDisplayValue] =
    useState<string>("");
  const [shouldClear, setShouldClear] = useState(false);

  useEffect(() => {
    if (shouldClear) {
      setRecipientInputDisplayValue("");
      setShouldClear(false);
    }
  }, [shouldClear]);

  return (
    <TableAutocomplete
      key={rowIndex}
      label={l10n.getString("type-search-label")}
      placeholder={l10n.getString("type-search-label")}
      hasError={error}
      footerContent={
        <Button
          size="s"
          kind="plain"
          onMouseDown={() => {
            handleClickAddRecipient(rowIndex);
          }}
          testId="add-recipient-button"
        >
          <span className="narmi-icon-plus margin--right--xs" />
          {l10n.getString("add-recipient-label")}
        </Button>
      }
      inputValue={recipientInputDisplayValue}
      onInputChange={(value: string) => {
        setRecipientInputDisplayValue(value);
      }}
      onChange={(value: string) => {
        const recipient = getRecipientById(
          recipients,
          value as API.RecipientId
        );
        if (recipient && !recipient.ach_destination) {
          // if recipient exists but doesn't have an ach destination, open the edit drawer with a custom alert to prompt user to add one
          setShouldClear(true);
          setCustomAlertCopy(l10n.getString("ach-payment-ach-details-banner"));
          handleClickEditRecipient(value as API.RecipientId, rowIndex);
        } else {
          // otherwise, just set the recipient id in the form
          form.setFieldValue(`payments.${rowIndex}.recipient`, recipient);
        }
      }}
    >
      {recipients.map((recipient) => (
        <TableAutocomplete.Item
          key={recipient.id}
          value={recipient.id}
          searchValue={recipient.name}
        >
          {recipient.name}
        </TableAutocomplete.Item>
      ))}
    </TableAutocomplete>
  );
};

export default RecipientSelector;
